import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import { mdiChevronLeft } from '@mdi/js'
import CheckInParticipantsRow from '@/components/CheckInParticipantsRow.vue'
import { useEventQuery, useEventAttendeesQuery } from '@/enitites/event/api/queries'
import { useVuetify } from '@/services/useVuetify'
// @ts-expect-error not ts file
import store from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckInParticipants',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const vuetify = useVuetify()

const eventId = Number(route.params.id)

const { data: event, isLoading: isEventLoading } = useEventQuery(eventId)
const {
  data: attendees,
  isLoading: isAttendeesLoading,
  isError: isAttendeesError,
  isFetching: isRefetching,
  refetch: refetchAttendees,
} = useEventAttendeesQuery(eventId)

const searchKeyword = ref('')
const isShowLegend = ref(false)

watch(
  [isEventLoading, event],
  ([isLoading, data]) => {
    if (!isLoading && !data) store.commit('setIsNotFound', true)
  },
  { immediate: true }
)

onMounted(() => {
  if (vuetify.breakpoint.mdAndUp) isShowLegend.value = true
})

const participants = computed(() => {
  if (!attendees.value) return []
  if (!searchKeyword.value) return attendees.value
  return attendees.value.filter((a) => a.dancerName.toLowerCase().includes(searchKeyword.value.toLowerCase()))
})

const participantsCount = computed(() => attendees.value?.length ?? 0)

const participantsCheckedInCount = computed(() => attendees.value?.filter((a) => a.checkedIn).length ?? 0)

const backToEvent = () => {
  router.push({ name: 'Event', params: { id: String(eventId) } })
}

return { __sfc: true,route, router, vuetify, eventId, event, isEventLoading, attendees, isAttendeesLoading, isAttendeesError, isRefetching, refetchAttendees, searchKeyword, isShowLegend, participants, participantsCount, participantsCheckedInCount, backToEvent, mdiChevronLeft, CheckInParticipantsRow }
}

})